<!-- prettier-ignore -->

<ion-header>
    <ion-toolbar class="pdf-toolbar">
      <ion-title>{{ name }}</ion-title>
      <div slot="end" class="zoom-buttons-container">
          <img draggable="false" src="/assets/imgs/zoom-.svg" (click)="zoomPDF('-')" alt="{{'Aumentar zoom' | translate}}" class="decrease"  />
          <img draggable="false" src="/assets/imgs/zoom+.svg" (click)="zoomPDF('+')" alt="{{'Disminuir zoom' | translate}}" class="increase" />
      </div>
      <ion-buttons slot="end" (click)="dismissModal()">
        <ion-icon name="close"></ion-icon>
      </ion-buttons>
    </ion-toolbar>
  </ion-header>

<ion-content class="pdf-content">
    <ngx-extended-pdf-viewer [src]="pdf" [showToolbar]="false" [zoom]="zoom" (pdfLoaded)="onPdfLoaded()" />
</ion-content>

